import { openFile } from 'core/utils/browser'

import {
  retrieveShipperAttachment,
  type RetrieveShipperAttachmentParams,
} from './retrieveShipperAttachment'

export type ViewShipperAttachmentParams = RetrieveShipperAttachmentParams

export async function viewShipperAttachment(
  params: ViewShipperAttachmentParams,
  config?: { signal?: AbortSignal }
): Promise<string> {
  const { fileUrl } = await retrieveShipperAttachment(params, config)
  openFile(fileUrl)
  return fileUrl
}
